// ============================================================
//  SERVER CONFIG — auto-detects environment, no manual change needed
// ============================================================
//
//  Running on localhost  → uses your local backend (port 3001)
//  Running on any domain → uses the Railway production backend
//
//  ✅ No need to change anything before pushing to GitHub!
// ============================================================

const IS_LOCAL =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');

const environments = {
  local: {
    BASE_URL: 'http://localhost:3001',
    API_URL:  'http://localhost:3001/api',
    label:    'Local Dev',
  },
  production: {
    BASE_URL: 'https://iso-compliance-backend-production-fb79.up.railway.app',
    API_URL:  'https://iso-compliance-backend-production-fb79.up.railway.app/api',
    label:    'Production (Railway)',
  },
};

const config = IS_LOCAL ? environments.local : environments.production;

console.log(`[ServerConfig] Environment: ${config.label} → ${config.API_URL}`);

export default config;
export const { BASE_URL, API_URL } = config;

